import { render, staticRenderFns } from "./area-raw-material-index.vue?vue&type=template&id=164b39cc&scoped=true&"
import script from "./area-raw-material-index.vue?vue&type=script&lang=js&"
export * from "./area-raw-material-index.vue?vue&type=script&lang=js&"
import style0 from "./area-raw-material-index.vue?vue&type=style&index=0&id=164b39cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b39cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164b39cc')) {
      api.createRecord('164b39cc', component.options)
    } else {
      api.reload('164b39cc', component.options)
    }
    module.hot.accept("./area-raw-material-index.vue?vue&type=template&id=164b39cc&scoped=true&", function () {
      api.rerender('164b39cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/area-raw-material-index.vue"
export default component.exports